import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "grid flex flex--wrap mb-24" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "grid__item a7-12 f6-6" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "h1" }, " Add new project ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "grid__item a5-12 f6-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "notice-bar notice-bar--header" }, [
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createElementVNode("b", null, "The status of this project is currently pending."),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" A project number will be assigned once it is ready to go live ")
      ])
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_4 = { class: "new-project-by-api" }
const _hoisted_5 = { class: "flex flex--wrap flex--gap-large flex--justify-space-between flex--align-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Please link this new project to the PandaDoc fee proposal.")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "iota" }, " Project title and scope will be pre-filled to save time. ")
], -1 /* HOISTED */)
const _hoisted_7 = ["onSubmit"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label form__label--small",
  for: "api-id"
}, " PandaDoc document ID (final part of URL, e.g. bT7ypof54GRE76) ", -1 /* HOISTED */)
const _hoisted_9 = { class: "flex flex--align-start flex--wrap flex--gap-medium" }
const _hoisted_10 = {
  key: 0,
  class: "form__error"
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "steps-nav" }
const _hoisted_13 = { class: "grid flex flex--wrap mb-24" }
const _hoisted_14 = { class: "grid__item a7-12 d6-6" }
const _hoisted_15 = { class: "steps" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        ($setup.loading)
          ? (_openBlock(), _createBlock($setup["PageLoaderComponent"], { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("form", {
                    class: "new-project-by-api__form",
                    onSubmit: _withModifiers($setup.makePandadocRequest, ["prevent"])
                  }, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          id: "api-id",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.form_fields.pandadoc_id) = $event)),
                          class: "form__input form__input--thin",
                          type: "text"
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, $setup.form_fields.pandadoc_id]
                        ]),
                        ($setup.form_errors.pandadoc_id)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($setup.form_errors.pandadoc_id), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("button", {
                        class: _normalizeClass(["button button--small", { 'button--loading': $setup.loading_pandadoc_request }]),
                        type: "submit",
                        disabled: $setup.loading_pandadoc_request
                      }, _toDisplayString($setup.loading_pandadoc_request ? 'Fetching...' : $setup.pandadoc_info_fetched ? 'Information fetched!' : 'Fetch this information'), 11 /* TEXT, CLASS, PROPS */, _hoisted_11)
                    ])
                  ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.steps, (step, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: 'steps-nav-' + index,
                    class: _normalizeClass(["steps-nav__step", ( step.step_number <= $setup.active_step_number ) ? ' steps-nav__step--active' : null])
                  }, [
                    _createElementVNode("p", {
                      class: _normalizeClass(["steps-nav__step-title", ( step.step_number < $setup.active_step_number ) ? ' steps-nav__step-title--completed' : null])
                    }, " Step " + _toDisplayString(step.step_number), 3 /* TEXT, CLASS */),
                    _createElementVNode("p", null, _toDisplayString(step.title), 1 /* TEXT */)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode($setup["ProjectDetailsComponent"], {
                      step: $setup.steps[0],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"]),
                    _createVNode($setup["ClientInformationComponent"], {
                      step: $setup.steps[1],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"]),
                    _createVNode($setup["ExternalTeamComponent"], {
                      step: $setup.steps[2],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"]),
                    _createVNode($setup["InternalTeamComponent"], {
                      step: $setup.steps[3],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"]),
                    _createVNode($setup["ProjectScopeComponent"], {
                      step: $setup.steps[4],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"]),
                    _createVNode($setup["ReviewComponent"], {
                      step: $setup.steps[5],
                      "active-step-number": $setup.active_step_number
                    }, null, 8 /* PROPS */, ["step", "active-step-number"])
                  ])
                ])
              ])
            ]))
      ]),
      _: 1 /* STABLE */
    })
  ]))
}